import { Helmet } from 'react-helmet-async';
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TextField,
  alertTitleClasses,
  Dialog,
  AppBar,
  Toolbar,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Styles/play.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FaArrowLeft } from 'react-icons/fa';
import 'katex/dist/katex.min.css';
import { BlockMath } from 'react-katex';
// import countdownSound from '../../public/assets/images/

import {
  initiateQuizStatus,
  startQuizStatus,
  getQuizsToPlay,
  quizStatusComplete,
  quizStatusNext,
  updatejoinStatus,
  getLeaderBoardData,
  getJoinedUser,
  getAttemptedUserList,
} from '../Servies/AdmiServices';
import Loader from '../components/common/Loader';
import Iconify from '../components/iconify';

export default function PlayQuizPage() {
  const [open, setOpen] = React.useState(false);
  const [joinedUser, setJoinedUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [currentQuizIndex, setCurrentQuizIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [leaderboardDialogOpen, setLeaderboardDialogOpen] = useState(false);
  const [leaderdata, setLeaderData] = useState([]);
  const [pollingInterval, setPollingInterval] = useState(null);
  const [countdown, setCountdown] = useState(5);
  const [countdownDialogOpen, setCountdownDialogOpen] = useState(false);
  const [showQuizPlay, setShowQuizPlay] = useState([]);
  const navigate = useNavigate();
  const [nextQuestionId, setNextQuestionId] = useState(null); // State variable to hold the next questionId
  const [isSubmitDialogOpen, setSubmitDialogOpen] = useState(false);
  const [prevLeaderData, setPrevLeaderData] = useState([]); // Add a new state variable for previous leader data
  const [isTestSubmitted, setIsTestSubmitted] = useState(false); // Initialize state variable for test submission status
  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const quizQuestionTimeInSeconds = params.get('quizQuestionTimeInSeconds'); // Move this line here
  const [remainingTime, setRemainingTime] = useState(parseInt(quizQuestionTimeInSeconds, 10)); // Use it here
  const [shouldFetchUsers, setShouldFetchUsers] = useState(true);
  const [intervalId, setIntervalId] = useState(null); // Store interval ID
  const [testInitiated, setTestInitiated] = useState(false);
  const [webSocket, setWebSocket] = useState(null); // WebSocket connection state
  const [isWebSocketConnected, setIsWebSocketConnected] = useState(false); // WebSocket connection status
  const [questionTimerRef, setQuestionTimerRef] = useState(null); // Store question timer interval

  const quizId = params.get('quizId');
  const attemptedUserCount = Array.isArray(users) ? users.filter((user) => user.attempted).length : 0;

  const quizCode = params.get('quizCode');
  console.log(quizCode, 'quizCode');
  const handleGoBack = () => {
    navigate('/dashboard/QuizDashboard');
  };

  const handleChangeToReport = (quizId) => {
    navigate(`/dashboard/QuizReports?quizId=${quizId}`);
  };

  const handleOpenUserDialog = () => {
    setUserDialogOpen(true);
  };

  const handleCloseUserDialog = () => {
    setUserDialogOpen(false);
  };

  useEffect(() => {
    // Close the popup automatically after 3 seconds
    const timeoutId = setTimeout(() => {
      setShowTimeoutPopup(false);
    }, 3000); // Adjust the duration as needed

    // Cleanup function to clear the timeout
    return () => {
      clearTimeout(timeoutId);
    };
  }, []); // This effect runs only once after the component mounts
  // Function to automatically close the timeout popup after 1 second
  useEffect(() => {
    // Set a timer to hide the popup after 1 second
    const timer = setTimeout(() => {
      setShowTimeoutPopup(false);
    }, 3000);

    // Clear the timer when the component unmounts or when showTimeoutPopup changes
    return () => clearTimeout(timer);
  }, [showTimeoutPopup]);

  const handleCloseTimeoutPopup = () => {
    setShowTimeoutPopup(false);
  };

  const defaultImages = [
    '/favicon/assasin.png',
    '/favicon/child.png',
    '/favicon/gladiator.png',
    '/favicon/viking.png',

    // Add more default image paths as needed
  ];

  const startQuestionTimer = () => {
    // Clear any existing timer first
    if (questionTimerRef) {
      clearInterval(questionTimerRef);
      setQuestionTimerRef(null);
    }

    const currentQuestion = showQuizPlay.data.questionsData[currentQuestionIndex];
    if (!currentQuestion) {
      // Handle the case where there is no current question
      return;
    }

    const quizQuestionTimeInSeconds = currentQuestion.questionTime;
    setRemainingTime(parseInt(quizQuestionTimeInSeconds, 10)); // Reset the timer to the initial value

    const questionTimer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime === 0 || prevTime <= 1) {
          clearInterval(questionTimer);
          setQuestionTimerRef(null);
          setShowTimeoutPopup(true); // Show timeout popup when time is up
          return 0; // Ensure the timer does not go into negative values
        }
        return prevTime - 1; // Decrement timer by 1 second
      });
    }, 1000);

    // Store the timer reference
    setQuestionTimerRef(questionTimer);
  };

  const startCountdown = () => {
    setCountdown(5); // Reset countdown to the initial value
    setCountdownDialogOpen(true); // Open the countdown dialog

    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(countdownInterval); // Clear the interval when countdown reaches zero
          setCountdownDialogOpen(false); // Close the countdown dialog
          startQuestionTimer(); // Start the question timer
          return 0;
        }
        return prevCountdown - 1; // Decrement countdown by 1 second
      });
    }, 1000);
  };

  const handleCloseSubmitDialog = () => {
    // Close the submit dialog
    setSubmitDialogOpen(false);
  };

  const handleShowLeaderBoard = () => {
    // Open the leaderboard Dialog
    getLeaderBoardData(quizId)
      .then((response) => {
        setLeaderData(response?.data.response);
        console.log(response?.data.response, 'check');
        setPrevLeaderData(leaderdata); // Save previous leader data

        setLeaderboardDialogOpen(true);
      })
      .catch((error) => {
        console.error('Update leader error:', error);
      });
  };
  // console.log(leaderdata, 'checkssss');

  // WebSocket setup for real-time participant updates
  useEffect(() => {
    let ws = null;

    const connectWebSocket = () => {
      try {
        // WebSocket URL with quizId parameter
        const wsUrl = `ws://164.52.209.128:8788/quiz`;

        console.log('🔄 Attempting to connect to WebSocket:', wsUrl);
        console.log('Quiz ID:', quizId);
        console.log('Test Initiated:', testInitiated);

        // Establish WebSocket connection
        ws = new WebSocket(wsUrl);

        ws.onopen = () => {
          console.log('✅ WebSocket connected successfully for quiz participants');
          console.log('WebSocket readyState:', ws.readyState);
          setIsWebSocketConnected(true);
          setWebSocket(ws);

      

          toast.success('Real-time updates connected!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        };

        ws.onmessage = (event) => {
          try {
            console.log('📨 Raw WebSocket message received:', event.data);
            const data = JSON.parse(event.data);
            console.log('📨 Parsed WebSocket message:', data);

            // Handle NEW_JOINEE action - Update joined users
            if (data.action === 'NEW_JOINEE') {
              if(quizId === data.quizId){
                console.log('👤 New participant joined! Fetching updated participant list...', quizId);

                // Call API to get updated participant data
                fetchJoinedUser();

                toast.info('New participant joined!', {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 2000,
                });
              }
            }

            // Handle ANSWER_SUBMIT action - Update attempted users list
            if (data.action === 'ANSWER_SUBMIT') {
              if(quizId === data.quizId){
                console.log('✍️ Answer submitted! Fetching updated attempt data...', quizId);

                // Get current question ID
                const currentQuestion = showQuizPlay?.data?.questionsData[currentQuestionIndex];
                if (currentQuestion) {
                  const questionId = currentQuestion.questionId;

                  // Call API to get updated attempted answer data
                  fetchUserList(questionId);

                  console.log('📊 Updated attempt data for question:', questionId);
                }
              }
            }
          } catch (error) {
            console.error('❌ Error parsing WebSocket message:', error);
            console.error('Raw data:', event.data);
          }
        };

        ws.onerror = (error) => {
          console.error('❌ WebSocket error occurred:', error);
          console.error('WebSocket URL:', wsUrl);
          console.error('WebSocket readyState:', ws?.readyState);
          setIsWebSocketConnected(false);

          toast.error('WebSocket connection failed. Using polling fallback.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
          });
        };

        ws.onclose = (event) => {
          console.log('🔌 WebSocket disconnected');
          console.log('Close code:', event.code);
          console.log('Close reason:', event.reason);
          console.log('Was clean:', event.wasClean);
          setIsWebSocketConnected(false);
          setWebSocket(null);
        };
      } catch (error) {
        console.error('❌ Failed to create WebSocket connection:', error);
        setIsWebSocketConnected(false);
      }
    };

    // Connect WebSocket automatically when quizId is available
    if (quizId) {
      console.log('🚀 Connecting WebSocket automatically on page load');
      console.log('Quiz ID:', quizId);
      connectWebSocket();
    } else {
      console.log('⏳ Waiting for quizId. Current quizId:', quizId);
    }

    // Cleanup WebSocket on unmount
    return () => {
      if (ws && ws.readyState === WebSocket.OPEN) {
        console.log('🧹 Cleaning up WebSocket connection');
        ws.close();
      }
    };
  }, [quizId]);

  // ... (rest of the code)
  const fetchJoinedUser = () => {
    setIsLoading(true);
    getJoinedUser(quizId)
      .then((response) => {
        setJoinedUser(response.data);
        setIsLoading(false);
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error:', error);
      });
  };

  const handleClickInitiate = () => {
    initiateQuizStatus(quizId, 'INITIATED')
      .then((res) => {
        toast.success('Quiz Initiated', {
          position: toast.POSITION.TOP_RIGHT,
        });

        // Set testInitiated to true to trigger WebSocket connection
        setTestInitiated(true);

        // Fetch initial participant list
        fetchJoinedUser();

        // Note: Polling is replaced by WebSocket for real-time updates
        // If WebSocket fails, fallback polling can be enabled
      })
      .catch((error) => {
        console.error('Update Initiate:', error);
      });
  };

  useEffect(() => {
    // Only use polling as fallback if WebSocket is not connected and quiz is initiated
    if (testInitiated && !isWebSocketConnected && quizId) {
      const intervalId = setInterval(fetchJoinedUser, 5000); // Poll every 5 seconds
      setPollingInterval(intervalId);

      console.log('⚠️ Using polling as fallback (WebSocket not connected)');
    } else if (isWebSocketConnected && pollingInterval) {
      // Stop polling if WebSocket is connected
      clearInterval(pollingInterval);
      setPollingInterval(null);
      console.log('✅ WebSocket connected, stopped polling');
    }

    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [testInitiated, isWebSocketConnected, quizId]);

  const stopPolling = () => {
    clearInterval(pollingInterval);
    setPollingInterval(null);
  };

  useEffect(() => {
    fetchJoinedUser();

    return () => {
      stopPolling();
    };
  }, [quizId]);
  // console.log(joinedUser, 'checker');

  const handleCloseLeaderboardDialog = () => {
    // Close the leaderboard Dialog
    setLeaderboardDialogOpen(false);
  };

  const handleClickOpen = () => {
    startCountdown();
    setTestInitiated(false);
    stopPolling(); // Stop polling when the quiz starts

    const currentQuestion = showQuizPlay?.data?.questionsData[currentQuestionIndex];
    if (!currentQuestion) {
      // Handle the case where there is no current question
      return;
    }

    const questionId = currentQuestion.questionId;
    const currentSequence = currentQuestion.sequence;

    setOpen(true);
    // Update every second
    startQuizStatus(quizId, 'STARTED', questionId, currentSequence)
      .then((res) => {
        console.log(res?.data, res?.data?.message);
        if (res.status === 200) {
          toast.success(res?.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setOpen(true);
          setTestInitiated(false);

          console.log('quizInMe', res?.data);
        } else {
          setOpen(false);
          toast.error(res?.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {});

    // Initial fetch to get current attempt data
    fetchUserList(questionId);

    // Note: Real-time updates now handled by WebSocket (ANSWER_SUBMIT action)
    // Polling removed to avoid unnecessary API calls
  };

  const handleQuizSubmit = () => {
    setOpen(true);
    setSubmitDialogOpen(true);
    // Note: No interval to clear - using WebSocket for real-time updates
    quizStatusComplete(quizId, 'COMPLETED')
      .then((res) => {
        console.log(res?.data, res?.data?.message);
        if (res.status === 200) {
          toast.success(res?.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setOpen(true);
          setIsTestSubmitted(true); // Update test submission status to true

          console.log('quizInMe', res?.data);
        } else {
          setOpen(false);
          toast.error(res?.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {});
  };

  const handleNotifi = () => {
    updatejoinStatus(quizId, 'NOT_STARTED')
      .then((res) => {
        console.log(res?.data, res?.data?.message);
        toast.success('Notification Send', {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        console.error('Error while sending Notification:', error);
      });
  };

  // Manual WebSocket test function
  const testWebSocketConnection = () => {
    console.log('🧪 MANUAL TEST: Attempting WebSocket connection...');
    console.log('🧪 Quiz ID:', quizId);
    console.log('🧪 Test Initiated:', testInitiated);

    const testWs = new WebSocket('ws://164.52.209.128:8788/quiz');

    testWs.onopen = () => {
      console.log('🧪 ✅ TEST SUCCESS: WebSocket connected!');
      toast.success('WebSocket test connection successful!', {
        position: toast.POSITION.TOP_RIGHT,
      });
    };

    testWs.onerror = (error) => {
      console.error('🧪 ❌ TEST FAILED: WebSocket error:', error);
      toast.error('WebSocket test failed - Check console for details', {
        position: toast.POSITION.TOP_RIGHT,
      });
    };

    testWs.onclose = (event) => {
      console.log('🧪 Connection closed. Code:', event.code, 'Reason:', event.reason);
    };

    testWs.onmessage = (event) => {
      console.log('🧪 📨 Received test message:', event.data);
    };
  };

  const handlesubmits = () => {
    setIsLoading(true);
    getQuizsToPlay(quizId)
      .then((response) => {
        setShowQuizPlay(response?.data);
        console.log('data', response?.data);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Update leader error:', error);
      });
  };
  // console.log(showQuizPlay);

  useEffect(() => {
    handlesubmits();
  }, []);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (questionTimerRef) {
        clearInterval(questionTimerRef);
      }
    };
  }, [questionTimerRef]);

  const startCountsdown = () => {
    setCountdownDialogOpen(true);
    // playCountdownSound(); // Play the countdown sound effect

    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Set a timeout to close the countdown dialog after the countdown finishes
    setTimeout(() => {
      setCountdownDialogOpen(false);
      clearInterval(countdownInterval); // Clear the interval
    }, 5000);
  };

  const fetchNextQuestions = () => {
    // Note: No interval to clear - using WebSocket for real-time updates
    console.log(currentQuizIndex, showQuizPlay.data?.questionsData.length, 'check index:)');
    if (showQuizPlay.data?.questionsData.length > currentQuizIndex + 1) {
      setCurrentQuestionIndex(currentQuizIndex + 1);
      startCountdown(); // Start the countdown
    } else {
      alert('Question over');
    }

    const nextQuestionIndex = currentQuestionIndex + 1;
    // Ensure that there is a next question available
    if (nextQuestionIndex < showQuizPlay.data?.questionsData.length) {
      const nextQuestionId = showQuizPlay.data?.questionsData[nextQuestionIndex].questionId;

      const currentSequence = showQuizPlay.data?.questionsData[nextQuestionIndex].sequence;

      quizStatusNext(quizId, nextQuestionId, 'STARTED', currentSequence)
        .then((response) => {
          console.log('Response body:', response.data.response);

          if (response.status === 200) {
            return response; // assuming the response is in JSON format
          }
          console.error('Failed to fetch next questions. Response:', response);
          return 'Failed to fetch next questions';
        })
        .then((data) => {
          if (data) {
            console.log('Data:', data);

            // Extract the next question from the array
            const nextQuestion = data.questionsData;

            // Update the state with the new question
            setShowQuizPlay((prevData) => ({
              ...prevData,
              questionsData: [...prevData.data.questionsData, nextQuestion],
            }));

            setCurrentQuestionIndex(nextQuestionIndex);

            // Initial fetch for next question's attempt data
            fetchUserList(nextQuestionId);

            // Note: Real-time updates now handled by WebSocket (ANSWER_SUBMIT action)
            // Polling removed to avoid unnecessary API calls
          }
        })
        .catch((error) => {
          console.error('Error fetching next questions:', error);
        });
    } else {
      console.log('No more questions available.');
    }
  };

  const fetchUserList = (questionId) => {
    setIsLoading(true);
    getAttemptedUserList(quizId, questionId)
      .then((response) => {
        setUsers(response.data);
        setIsLoading(false);
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error:', error);
      });
  };

  // Polling disabled - Real-time updates now handled by WebSocket (ANSWER_SUBMIT action)
  // useEffect(() => {
  //   let intervalId;

  //   // Define a function to start the interval
  //   const startInterval = (nextQuestionId) => {
  //     intervalId = setInterval(() => {
  //       if (nextQuestionId) {
  //         fetchUserList(nextQuestionId);
  //       }
  //     }, 1000); // Refresh every second
  //   };

  //   // Start the interval only if the condition is met
  //   if (shouldFetchUsers && nextQuestionId) {
  //     startInterval(nextQuestionId);
  //   }

  //   // Cleanup function to clear the interval
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, [shouldFetchUsers, nextQuestionId]);

  const handleClose = () => {
    setOpen(false);
  };

  function generateRandomColor() {
    const letters = '0123456789ABCDEF';

    // Use Array.from to create an array with 6 elements
    const colorArray = Array.from({ length: 6 }, () => {
      const randomIndex = Math.floor(Math.random() * 16);
      return letters[randomIndex];
    });

    // Join the array elements to form the color string
    return `#${colorArray.join('')}`;
  }

  // Function to get the CSS class for rank change animation
  const getRankChangeClass = (currentRank, index) => {
    const prevRank = prevLeaderData[index]?.rank || 0; // Get previous rank if available
    if (currentRank < prevRank) {
      return 'rank-down'; // CSS class for rank decrease
    }
    if (currentRank > prevRank) {
      return 'rank-up'; // CSS class for rank increase
    }
    return ''; // No change in rank
  };

  return (
    <>
      {isLoading && <Loader />}

      <ToastContainer />
      <Helmet>
        <title> PlayQuiz </title>
      </Helmet>
      <Container>
        <FaArrowLeft
          style={{
            cursor: 'pointer',
            gap: '2rem',
            height: '40px',
            width: '40px',
            backgroundColor: '#86A8CF',
            borderRadius: '60%',
          }}
          onClick={handleGoBack} // Pass the user ID to the delete handler
        />
        <br />
        <br />
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} flexWrap="wrap" gap={2}>
          <Typography
            variant="h2"
            gutterBottom
            sx={{ display: 'flex', alignItems: 'center', gap: '1rem', margin: 0 }}
          >
            <img src="\favicon\download.jpg" alt="Quiz Icon" height={65} width={65} />
            Manage Quiz
          </Typography>
          <Stack direction="row" gap={2} flexWrap="wrap">
            <Button
              variant="contained"
              onClick={handleNotifi}
              startIcon={<Iconify icon="mdi:bell-outline" />}
            >
              Send Notification
            </Button>
            <Button
              variant="contained"
              onClick={handleClickInitiate}
              color="primary"
              startIcon={<Iconify icon="mdi:play-circle-outline" />}
            >
              Initiate Quiz
            </Button>
            <Button
              variant="contained"
              onClick={handleClickOpen}
              color="success"
              startIcon={<Iconify icon="mdi:rocket-launch" />}
            >
              Start Quiz
            </Button>
            <Button
              variant="outlined"
              color="warning"
              onClick={testWebSocketConnection}
              startIcon={<Iconify icon="mdi:lan-connect" />}
            >
              Test WebSocket
            </Button>
          </Stack>
        </Stack>
        <Card sx={{ p: 3, mb: 3 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Joined Participants: <span style={{ color: '#1976d2' }}>{joinedUser.length}</span>
              </Typography>
              {isWebSocketConnected && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    py: 0.5,
                    bgcolor: '#e8f5e9',
                    borderRadius: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      bgcolor: '#4caf50',
                      borderRadius: '50%',
                      animation: 'pulse 2s infinite',
                    }}
                  />
                  <Typography variant="caption" sx={{ color: '#2e7d32', fontWeight: 500 }}>
                    Live
                  </Typography>
                </Box>
              )}
              {!isWebSocketConnected && testInitiated && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    py: 0.5,
                    bgcolor: '#fff3e0',
                    borderRadius: 1,
                  }}
                >
                  <Box sx={{ width: 8, height: 8, bgcolor: '#ff9800', borderRadius: '50%' }} />
                  <Typography variant="caption" sx={{ color: '#e65100', fontWeight: 500 }}>
                    Polling
                  </Typography>
                </Box>
              )}
            </Stack>
            <Typography variant="h6" sx={{ color: '#666', fontWeight: 500 }}>
              Quiz Code: <span style={{ color: '#1976d2', fontFamily: 'monospace' }}>{quizCode}</span>
            </Typography>
          </Stack>

          <Stack direction="row" flexWrap="wrap" gap={2}>
            {joinedUser.map((value, index) => (
              <Card
                key={index}
                sx={{
                  minWidth: 250,
                  bgcolor: generateRandomColor(),
                  color: 'white',
                  '&:hover': { transform: 'scale(1.02)', transition: 'transform 0.2s' },
                }}
              >
                <Stack direction="row" alignItems="center" gap={2} p={2}>
                  <img
                    src={value.img || defaultImages[index % defaultImages.length]}
                    height={50}
                    width={50}
                    alt={value.username}
                    style={{ borderRadius: '50%', border: '2px solid white' }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600, color: 'white' }}>
                    {value.username}
                  </Typography>
                </Stack>
              </Card>
            ))}
            {joinedUser.length === 0 && (
              <Typography variant="body1" color="text.secondary" sx={{ py: 4, textAlign: 'center', width: '100%' }}>
                No participants have joined yet. Waiting for participants to join...
              </Typography>
            )}
          </Stack>
        </Card>
        <Dialog className="quizpage" fullScreen open={open} onClose={handleClose}>
          <AppBar sx={{ position: 'relative', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
              <Stack direction="row" alignItems="center" gap={2}>
                <Button
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  startIcon={<Iconify icon="mdi:close" />}
                  sx={{ fontWeight: 600 }}
                >
                  Close
                </Button>
                <Stack direction="row" alignItems="center" gap={1}>
                  <img src="\favicon\quizicon.png" alt="quiz" height={40} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Play Quiz • <span style={{ fontFamily: 'monospace' }}>{quizCode}</span>
                  </Typography>
                </Stack>
              </Stack>

              <Card
                sx={{
                  px: 3,
                  py: 1.5,
                  bgcolor: remainingTime > 10 ? '#fff' : '#ffebee',
                  boxShadow: 3,
                  borderRadius: 2,
                }}
              >
                <Stack direction="row" alignItems="center" gap={1.5}>
                  <Iconify
                    icon="mdi:clock-outline"
                    sx={{
                      fontSize: 28,
                      color: remainingTime > 10 ? '#1976d2' : '#d32f2f',
                    }}
                  />
                  <Stack>
                    <Typography variant="caption" sx={{ color: '#666', fontSize: 10 }}>
                      Time Remaining
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: remainingTime > 10 ? '#1976d2' : '#d32f2f',
                        fontFamily: 'monospace',
                      }}
                    >
                      {remainingTime}s
                    </Typography>
                  </Stack>
                </Stack>
              </Card>
            </Toolbar>
          </AppBar>
          <Container maxWidth="lg" sx={{ py: 4, minHeight: 'calc(100vh - 180px)' }}>

            {showQuizPlay && showQuizPlay.data?.questionsData ? (
              showQuizPlay.data?.questionsData.map((question, index) => {
                if (index === currentQuizIndex) {
                  return (
                    <Card
                      key={showQuizPlay.data?.questionsData[currentQuestionIndex].questionId}
                      sx={{
                        p: 4,
                        mb: 3,
                        boxShadow: 4,
                        borderRadius: 3,
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                      }}
                    >
                      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                        <Card
                          sx={{
                            px: 2,
                            py: 1,
                            bgcolor: '#e3f2fd',
                            border: '2px solid #2196f3',
                          }}
                        >
                          <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 700 }}>
                            Question {currentQuestionIndex + 1} / {showQuizPlay.data?.questionsData.length}
                          </Typography>
                        </Card>

                        <Button
                          variant="contained"
                          size="large"
                          startIcon={<Iconify icon="mdi:account-check" />}
                          onClick={handleOpenUserDialog}
                          sx={{
                            bgcolor: '#4caf50',
                            '&:hover': { bgcolor: '#45a049' },
                            fontWeight: 600,
                          }}
                        >
                          Attempted: {users?.questionAttemptedCount}
                        </Button>
                      </Stack>

                      <Card
                        sx={{
                          p: 3,
                          mb: 3,
                          bgcolor: '#fff',
                          border: '2px solid #e0e0e0',
                          borderRadius: 2,
                        }}
                      >
                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#333', lineHeight: 1.6 }}>
                          {showQuizPlay.data?.questionsData[currentQuestionIndex].title.map((part, i) => {
                            if (part.type === 'text') {
                              return (
                                <span
                                  key={i}
                                  style={{
                                    fontFamily: part.font,
                                    fontSize: '24px',
                                  }}
                                >
                                  {part.content}
                                </span>
                              );
                            }
                            if (part.type === 'latex') {
                              return <BlockMath key={i}>{part.content}</BlockMath>;
                            }
                            if (part.type === 'image') {
                              return (
                                <img
                                  key={i}
                                  src={part.content}
                                  alt={`Question ${index} Img`}
                                  style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '16px' }}
                                />
                              );
                            }
                            return null;
                          })}
                        </Typography>
                      </Card>

                      <Stack spacing={2}>
                        {showQuizPlay.data?.questionsData[currentQuestionIndex].answers.map((answer, ansIndex) => {
                          const isCorrect = answer.correctAnswer;
                          return (
                            <Card
                              key={answer.answerId}
                              sx={{
                                p: 2.5,
                                bgcolor: isCorrect ? '#e8f5e9' : '#f5f5f5',
                                border: isCorrect ? '3px solid #4caf50' : '2px solid #e0e0e0',
                                borderRadius: 2,
                                transition: 'all 0.3s',
                                position: 'relative',
                                '&:hover': {
                                  transform: 'translateY(-2px)',
                                  boxShadow: 4,
                                },
                              }}
                            >
                              <Stack direction="row" alignItems="center" gap={2}>
                                <Card
                                  sx={{
                                    minWidth: 40,
                                    minHeight: 40,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: isCorrect ? '#4caf50' : '#9e9e9e',
                                    color: 'white',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                  }}
                                >
                                  {String.fromCharCode(65 + ansIndex)}
                                </Card>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    color: isCorrect ? '#2e7d32' : '#333',
                                    fontWeight: isCorrect ? 600 : 500,
                                    flex: 1,
                                  }}
                                >
                                  {answer.title.map((part, i) => {
                                    if (part.type === 'text') {
                                      return (
                                        <span key={i} style={{ fontFamily: part.font, fontSize: '18px' }}>
                                          {part.content}
                                        </span>
                                      );
                                    }
                                    if (part.type === 'latex') {
                                      return <BlockMath key={i}>{part.content}</BlockMath>;
                                    }
                                    if (part.type === 'image') {
                                      return (
                                        <img
                                          key={i}
                                          src={part.content}
                                          alt={`Answer ${answer.answerId} Img`}
                                          style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '8px' }}
                                        />
                                      );
                                    }
                                    return null;
                                  })}
                                </Typography>
                                {isCorrect && (
                                  <Iconify
                                    icon="mdi:check-circle"
                                    sx={{ fontSize: 32, color: '#4caf50' }}
                                  />
                                )}
                              </Stack>
                            </Card>
                          );
                        })}
                      </Stack>
                    </Card>
                  );
                }
                return false;
              })
            ) : (
              <Card sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary">
                  Loading questions...
                </Typography>
              </Card>
            )}
          </Container>

          <Card
            sx={{
              position: 'sticky',
              bottom: 0,
              p: 2,
              boxShadow: 6,
              borderTop: '2px solid #e0e0e0',
              bgcolor: '#fff',
            }}
          >
            <Stack direction="row" justifyContent="center" gap={2} flexWrap="wrap">
              <Button
                variant="contained"
                size="large"
                onClick={fetchNextQuestions}
                startIcon={<Iconify icon="mdi:arrow-right-circle" />}
                sx={{
                  minWidth: 150,
                  bgcolor: '#2196f3',
                  '&:hover': { bgcolor: '#1976d2' },
                  fontWeight: 600,
                }}
              >
                Next Question
              </Button>

              <Button
                variant="contained"
                size="large"
                onClick={handleShowLeaderBoard}
                startIcon={<Iconify icon="mdi:trophy" />}
                sx={{
                  minWidth: 150,
                  bgcolor: '#ff9800',
                  '&:hover': { bgcolor: '#f57c00' },
                  fontWeight: 600,
                }}
              >
                Leaderboard
              </Button>

              <Button
                variant="contained"
                size="large"
                color="success"
                onClick={handleQuizSubmit}
                startIcon={<Iconify icon="mdi:check-circle" />}
                sx={{
                  minWidth: 150,
                  fontWeight: 600,
                }}
              >
                Submit Test
              </Button>

              {isTestSubmitted && (
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => handleChangeToReport(quizId)}
                  startIcon={<Iconify icon="mdi:file-chart" />}
                  sx={{
                    minWidth: 150,
                    bgcolor: '#9c27b0',
                    '&:hover': { bgcolor: '#7b1fa2' },
                    fontWeight: 600,
                  }}
                >
                  View Reports
                </Button>
              )}
            </Stack>
          </Card>
        </Dialog>
        <Dialog
          fullWidth
          maxWidth="md"
          open={leaderboardDialogOpen}
          onClose={handleCloseLeaderboardDialog}
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '90vh',
            },
          }}
        >
          <DialogTitle
            sx={{
              background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
              color: 'white',
              py: 3,
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack direction="row" alignItems="center" gap={2}>
                <Iconify icon="mdi:trophy" sx={{ fontSize: 40 }} />
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    Leaderboard
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Total Participants: {joinedUser.length}
                  </Typography>
                </Box>
              </Stack>
              <Button
                onClick={handleCloseLeaderboardDialog}
                sx={{ color: 'white', minWidth: 'auto' }}
                startIcon={<Iconify icon="mdi:close" />}
              >
                Close
              </Button>
            </Stack>
          </DialogTitle>

          <DialogContent sx={{ p: 3, bgcolor: '#f5f5f5' }}>
            <Stack spacing={2}>
              {leaderdata.length === 0 ? (
                <Card sx={{ p: 4, textAlign: 'center' }}>
                  <Typography variant="h6" color="text.secondary">
                    No participants have answered yet
                  </Typography>
                </Card>
              ) : (
                leaderdata.map((value, index) => {
                  const isTop3 = index < 3;
                  const rankColors = ['#ffd700', '#c0c0c0', '#cd7f32']; // Gold, Silver, Bronze
                  const isCorrect = value.questionAccuracyResponse.isAnsTrue;

                  return (
                    <Card
                      key={index}
                      className={getRankChangeClass(value.rank, index)}
                      sx={{
                        p: 2.5,
                        background: isCorrect
                          ? 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'
                          : 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
                        border: isTop3 ? `3px solid ${rankColors[index]}` : '2px solid #e0e0e0',
                        borderRadius: 2,
                        transition: 'all 0.3s',
                        '&:hover': {
                          transform: 'translateX(8px)',
                          boxShadow: 4,
                        },
                      }}
                    >
                      <Stack direction="row" alignItems="center" gap={3}>
                        {/* Rank Badge */}
                        <Box sx={{ position: 'relative' }}>
                          {isTop3 ? (
                            <Box
                              sx={{
                                width: 60,
                                height: 60,
                                bgcolor: rankColors[index],
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: 3,
                                border: '3px solid white',
                              }}
                            >
                              <Iconify
                                icon={
                                  index === 0
                                    ? 'mdi:trophy'
                                    : index === 1
                                    ? 'mdi:medal'
                                    : 'mdi:medal-outline'
                                }
                                sx={{ fontSize: 32, color: 'white' }}
                              />
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                width: 50,
                                height: 50,
                                bgcolor: '#9e9e9e',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 700,
                                fontSize: 20,
                              }}
                            >
                              {index + 1}
                            </Box>
                          )}
                        </Box>

                        {/* User Avatar */}
                        <img
                          src={value.profilePic || defaultImages[index % defaultImages.length]}
                          height={60}
                          width={60}
                          alt={value.userName}
                          style={{
                            borderRadius: '50%',
                            border: '3px solid white',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          }}
                        />

                        {/* User Info */}
                        <Stack flex={1}>
                          <Typography variant="h6" sx={{ fontWeight: 600, color: '#333' }}>
                            {value.userName}
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#666' }}>
                            Rank #{value.rank}
                          </Typography>
                        </Stack>

                        {/* Answer Status */}
                        <Card
                          sx={{
                            px: 2,
                            py: 1,
                            bgcolor: isCorrect ? '#4caf50' : '#f44336',
                            color: 'white',
                          }}
                        >
                          <Stack direction="row" alignItems="center" gap={1}>
                            <Iconify
                              icon={isCorrect ? 'mdi:check-circle' : 'mdi:close-circle'}
                              sx={{ fontSize: 24 }}
                            />
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {isCorrect ? 'Correct' : 'Wrong'}
                            </Typography>
                          </Stack>
                        </Card>

                        {/* Points */}
                        <Card
                          sx={{
                            px: 3,
                            py: 1.5,
                            bgcolor: '#fff',
                            border: '2px solid #2196f3',
                            minWidth: 100,
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="caption" sx={{ color: '#666', fontSize: 10 }}>
                            Points
                          </Typography>
                          <Typography variant="h6" sx={{ fontWeight: 700, color: '#2196f3' }}>
                            {value.pointAssigned}
                          </Typography>
                        </Card>
                      </Stack>
                    </Card>
                  );
                })
              )}
            </Stack>
          </DialogContent>

          <DialogActions sx={{ p: 3, bgcolor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
            <Button
              variant="contained"
              onClick={handleCloseLeaderboardDialog}
              size="large"
              sx={{
                bgcolor: '#ff9800',
                '&:hover': { bgcolor: '#f57c00' },
                fontWeight: 600,
                px: 4,
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={countdownDialogOpen}
          onClose={() => setCountdownDialogOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 4,
              overflow: 'hidden',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            },
          }}
        >
          <DialogContent sx={{ p: 0 }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 6,
                px: 4,
                color: 'white',
              }}
            >
              {/* Rocket Icon */}
              <Box
                sx={{
                  mb: 3,
                  animation: 'bounce 1s infinite',
                  '@keyframes bounce': {
                    '0%, 100%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(-20px)' },
                  },
                }}
              >
                <Iconify icon="mdi:rocket-launch" sx={{ fontSize: 80, color: '#fff' }} />
              </Box>

              {/* Title */}
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 1,
                  textAlign: 'center',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
                }}
              >
                Get Ready!
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 4,
                  opacity: 0.9,
                  textAlign: 'center',
                }}
              >
                Next question loading in...
              </Typography>

              {/* Circular Countdown */}
              <Box sx={{ position: 'relative', display: 'inline-flex', mb: 3 }}>
                {/* Outer Circle */}
                <Box
                  sx={{
                    width: 180,
                    height: 180,
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                    animation: 'pulse 1s infinite',
                    '@keyframes pulse': {
                      '0%, 100%': {
                        transform: 'scale(1)',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                      },
                      '50%': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
                      },
                    },
                  }}
                >
                  {/* Inner Circle */}
                  <Box
                    sx={{
                      width: 150,
                      height: 150,
                      borderRadius: '50%',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      boxShadow: 'inset 0 4px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <Typography
                      variant="h1"
                      sx={{
                        fontWeight: 900,
                        fontSize: '72px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        lineHeight: 1,
                      }}
                    >
                      {countdown}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#666',
                        fontWeight: 600,
                        mt: 0.5,
                      }}
                    >
                      seconds
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Progress Dots */}
              <Stack direction="row" spacing={1.5}>
                {[1, 2, 3, 4, 5].map((dot) => (
                  <Box
                    key={dot}
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      bgcolor: countdown <= 5 - dot + 1 ? 'white' : 'rgba(255,255,255,0.3)',
                      transition: 'all 0.3s',
                      boxShadow: countdown <= 5 - dot + 1 ? '0 0 8px rgba(255,255,255,0.8)' : 'none',
                    }}
                  />
                ))}
              </Stack>
            </Box>
          </DialogContent>
        </Dialog>
        {/* Submit Dialog */}
        <Dialog
          open={isSubmitDialogOpen}
          onClose={handleCloseSubmitDialog}
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 3,
              overflow: 'hidden',
            },
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
              color: 'white',
              p: 4,
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
              }}
            >
              <Iconify icon="mdi:check-circle" sx={{ fontSize: 50, color: '#4caf50' }} />
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Test Submitted!
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
              Your quiz has been successfully submitted
            </Typography>
          </Box>
          <DialogContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              All participant responses have been recorded. You can now view the detailed reports and analytics.
            </Typography>
            <Button
              variant="contained"
              onClick={handleCloseSubmitDialog}
              size="large"
              sx={{
                bgcolor: '#4caf50',
                '&:hover': { bgcolor: '#388e3c' },
                fontWeight: 600,
                px: 4,
              }}
            >
              Close
            </Button>
          </DialogContent>
        </Dialog>

        {/* Timeout Popup */}
        <Dialog
          open={showTimeoutPopup}
          onClose={() => setShowTimeoutPopup(false)}
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 3,
              overflow: 'hidden',
            },
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(135deg, #ff5252 0%, #d32f2f 100%)',
              color: 'white',
              p: 4,
              textAlign: 'center',
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                bgcolor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                animation: 'shake 0.5s',
                '@keyframes shake': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '25%': { transform: 'translateX(-10px)' },
                  '75%': { transform: 'translateX(10px)' },
                },
              }}
            >
              <Iconify icon="mdi:clock-alert" sx={{ fontSize: 50, color: '#ff5252' }} />
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Time's Up!
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
              Question time has expired
            </Typography>
          </Box>
          <DialogContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              The time allocated for this question has ended. Please proceed to the next question when ready.
            </Typography>
            <Button
              variant="contained"
              onClick={() => setShowTimeoutPopup(false)}
              size="large"
              sx={{
                bgcolor: '#ff5252',
                '&:hover': { bgcolor: '#d32f2f' },
                fontWeight: 600,
                px: 4,
              }}
            >
              OK, Got It
            </Button>
          </DialogContent>
        </Dialog>
        {/* User Attempt Status Dialog */}
        <Dialog
          open={userDialogOpen}
          onClose={handleCloseUserDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              maxHeight: '85vh',
            },
          }}
        >
          <DialogTitle
            sx={{
              background: 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)',
              color: 'white',
              py: 3,
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Stack direction="row" alignItems="center" gap={2}>
                <Iconify icon="mdi:account-check-outline" sx={{ fontSize: 40 }} />
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Question Attempt Status
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Track participant responses in real-time
                  </Typography>
                </Box>
              </Stack>
              <Button
                onClick={handleCloseUserDialog}
                sx={{ color: 'white', minWidth: 'auto' }}
                startIcon={<Iconify icon="mdi:close" />}
              >
                Close
              </Button>
            </Stack>
          </DialogTitle>

          <DialogContent sx={{ p: 3, bgcolor: '#f5f5f5' }}>
            {Array.isArray(users?.questionAttemptUserResponses) ? (
              <>
                {/* Statistics Summary */}
                <Stack direction="row" spacing={2} mb={3}>
                  <Card sx={{ flex: 1, p: 2.5, bgcolor: '#e8f5e9', border: '2px solid #4caf50' }}>
                    <Stack direction="row" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 50,
                          height: 50,
                          bgcolor: '#4caf50',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Iconify icon="mdi:check-circle" sx={{ fontSize: 28, color: 'white' }} />
                      </Box>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                          {users.questionAttemptUserResponses.filter((user) => user.isQuestionAttempt).length}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          Attempted
                        </Typography>
                      </Box>
                    </Stack>
                  </Card>

                  <Card sx={{ flex: 1, p: 2.5, bgcolor: '#fff3e0', border: '2px solid #ff9800' }}>
                    <Stack direction="row" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 50,
                          height: 50,
                          bgcolor: '#ff9800',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Iconify icon="mdi:clock-alert-outline" sx={{ fontSize: 28, color: 'white' }} />
                      </Box>
                      <Box>
                        <Typography variant="h4" sx={{ fontWeight: 700, color: '#e65100' }}>
                          {users.questionAttemptUserResponses.filter((user) => !user.isQuestionAttempt).length}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          Pending
                        </Typography>
                      </Box>
                    </Stack>
                  </Card>
                </Stack>

                {/* Attempted Users Section */}
                <Card sx={{ mb: 3, overflow: 'hidden' }}>
                  <Box
                    sx={{
                      bgcolor: '#4caf50',
                      color: 'white',
                      px: 3,
                      py: 2,
                    }}
                  >
                    <Stack direction="row" alignItems="center" gap={1.5}>
                      <Iconify icon="mdi:check-circle" sx={{ fontSize: 24 }} />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Attempted Users ({users.questionAttemptUserResponses.filter((user) => user.isQuestionAttempt).length})
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ p: 2, bgcolor: 'white', maxHeight: 300, overflow: 'auto' }}>
                    {users.questionAttemptUserResponses.filter((user) => user.isQuestionAttempt).length === 0 ? (
                      <Typography variant="body1" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                        No users have attempted yet
                      </Typography>
                    ) : (
                      <Stack spacing={1.5}>
                        {users.questionAttemptUserResponses
                          .filter((user) => user.isQuestionAttempt)
                          .map((user, index) => (
                            <Card
                              key={index}
                              sx={{
                                p: 2,
                                bgcolor: '#f1f8f4',
                                border: '1px solid #c8e6c9',
                                '&:hover': { bgcolor: '#e8f5e9' },
                              }}
                            >
                              <Stack direction="row" alignItems="center" gap={2}>
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    bgcolor: '#4caf50',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontWeight: 700,
                                  }}
                                >
                                  {index + 1}
                                </Box>
                                <Typography variant="body1" sx={{ fontWeight: 500, flex: 1 }}>
                                  {user.username}
                                </Typography>
                                <Iconify icon="mdi:check-circle" sx={{ fontSize: 24, color: '#4caf50' }} />
                              </Stack>
                            </Card>
                          ))}
                      </Stack>
                    )}
                  </Box>
                </Card>

                {/* Unattempted Users Section */}
                <Card sx={{ overflow: 'hidden' }}>
                  <Box
                    sx={{
                      bgcolor: '#ff9800',
                      color: 'white',
                      px: 3,
                      py: 2,
                    }}
                  >
                    <Stack direction="row" alignItems="center" gap={1.5}>
                      <Iconify icon="mdi:clock-alert-outline" sx={{ fontSize: 24 }} />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Pending Users ({users.questionAttemptUserResponses.filter((user) => !user.isQuestionAttempt).length})
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ p: 2, bgcolor: 'white', maxHeight: 300, overflow: 'auto' }}>
                    {users.questionAttemptUserResponses.filter((user) => !user.isQuestionAttempt).length === 0 ? (
                      <Typography variant="body1" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                        All users have attempted this question! 🎉
                      </Typography>
                    ) : (
                      <Stack spacing={1.5}>
                        {users.questionAttemptUserResponses
                          .filter((user) => !user.isQuestionAttempt)
                          .map((user, index) => (
                            <Card
                              key={index}
                              sx={{
                                p: 2,
                                bgcolor: '#fff8e1',
                                border: '1px solid #ffe0b2',
                                '&:hover': { bgcolor: '#fff3e0' },
                              }}
                            >
                              <Stack direction="row" alignItems="center" gap={2}>
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    bgcolor: '#ff9800',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontWeight: 700,
                                  }}
                                >
                                  {index + 1}
                                </Box>
                                <Typography variant="body1" sx={{ fontWeight: 500, flex: 1 }}>
                                  {user.username}
                                </Typography>
                                <Iconify icon="mdi:clock-outline" sx={{ fontSize: 24, color: '#ff9800' }} />
                              </Stack>
                            </Card>
                          ))}
                      </Stack>
                    )}
                  </Box>
                </Card>
              </>
            ) : (
              <Card sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary">
                  No data available
                </Typography>
              </Card>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 3, bgcolor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
            <Button
              variant="contained"
              onClick={handleCloseUserDialog}
              size="large"
              sx={{
                bgcolor: '#4caf50',
                '&:hover': { bgcolor: '#388e3c' },
                fontWeight: 600,
                px: 4,
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}
